export const SET_ACTIVE_LABEL = '[Record Labels] Set active';

export const GET_RECORD_LABELS = '[Record Labels] Get Record Labels';
export const GET_RECORD_LABELS_SUCCESS =
  '[Record Labels] Get Record Labels Success';
export const GET_RECORD_LABELS_ERROR =
  '[Record Labels] Get Record Labels Error';

export const GET_ARTIST_RECORD_LABELS =
  '[Record Labels] Get artist Record Labels';
export const GET_ARTIST_RECORD_LABELS_SUCCESS =
  '[Record Labels] Get artist Record Labels Success';
export const GET_ARTIST_RECORD_LABELS_ERROR =
  '[Record Labels] Get artist Record Labels Error';

export const LIST_RECORD_LABEL_ARTIST =
  '[Record Labels] List Record Label Artist';
export const LIST_RECORD_LABEL_ARTIST_SUCCESS =
  '[Record Labels] List Record Label Artist Success';
export const LIST_RECORD_LABEL_ARTIST_ERROR =
  '[Record Labels] List Record Label Artist Error';

export const CREATE_RECORD_LABEL = '[Record Labels] Create Record Label';
export const CREATE_RECORD_LABEL_SUCCESS =
  '[Record Labels] Create Record Label Success';
export const CREATE_RECORD_LABEL_ERROR =
  '[Record Labels] Create Record Label Error';

export const DELETE_RECORD_LABEL = '[Record Labels] Delete Record Labels';
export const DELETE_RECORD_LABEL_SUCCESS =
  '[Record Labels] Delete Record Labels Success';
export const DELETE_RECORD_LABEL_ERROR =
  '[Record Labels] Delete Record Labels Error';

export const DOWNGRADE_RECORD_LABEL = '[Record Labels] Downgrade Record Label';
export const DOWNGRADE_RECORD_LABEL_SUCCESS =
  '[Record Labels] Downgrade Record Label Success';
export const DOWNGRADE_RECORD_LABEL_ERROR =
  '[Record Labels] Downgrade Record Label Error';

export const UPDATE_RECORD_LABEL = '[Record Labels] Update Record Label';
export const UPDATE_RECORD_LABEL_ARTIST_COUNT =
  '[Record Labels] UPDATE_RECORD_LABEL_ARTIST_COUNT';
export const UPDATE_RECORD_LABEL_SUCCESS =
  '[Record Labels] Update Record Label Success';
export const UPDATE_RECORD_LABEL_ERROR =
  '[Record Labels] Update Record Label Error';

export const UPDATE_RECORD_LABEL_RELATION =
  '[Record Labels] Update Record Label relation';
export const UPDATE_RECORD_LABEL_RELATION_SUCCESS =
  '[Record Labels] Update Record Label relation Success';
export const UPDATE_RECORD_LABEL_RELATION_ERROR =
  '[Record Labels] Update Record Label relation Error';

export const ATTACH_TO_RECORD_LABEL = '[Record Labels] Attach to Record Label';
export const ATTACH_TO_RECORD_LABEL_SUCCESS =
  '[Record Labels] Attach to Record Label Success';
export const ATTACH_TO_RECORD_LABEL_ERROR =
  '[Record Labels] Attach to Record Label Error';

export const REMOVE_FROM_RECORD_LABEL =
  '[Record Labels] Remove from Record Label';
export const REMOVE_FROM_RECORD_LABEL_SUCCESS =
  '[Record Labels] Remove from Record Label Success';
export const REMOVE_FROM_RECORD_LABEL_ERROR =
  '[Record Labels] Remove  Record Label Error';

export const RESTORE_RECORD_LABEL = '[Record Labels] Restore Record Label';
export const RESTORE_RECORD_LABEL_SUCCESS =
  '[Record Labels] Restore Record Label Success';
export const RESTORE_RECORD_LABEL_ERROR = '[Record Labels] Restore Label Error';

export const CREATE_RECORD_LABEL_ONBOARDING =
  '[Record Labels] Create Record Label Onboarding';
export const CREATE_RECORD_LABEL_ONBOARDING_SUCCESS =
  '[Record Labels] Create Record Label Onboarding Success';
export const CREATE_RECORD_LABEL_ONBOARDING_ERROR =
  '[Record Labels] Create Record Label Onboarding Error';

export const UPDATE_RECORD_LABEL_NAME =
  '[Record Labels] Update Record Label name';
export const UPDATE_RECORD_LABEL_RELATION_SPLIT =
  '[Record Labels] Update Record Label relation split';

export const LIST_RECORD_LABEL_OPERATORS =
  '[Record Labels] List Record Label Operators';
export const LIST_RECORD_LABEL_OPERATORS_SUCCESS =
  '[Record Labels] List Record Label Operators Success';
export const LIST_RECORD_LABEL_OPERATORS_ERROR =
  '[Record Labels] List Record Label Operators Error';

export const CREATE_RECORD_LABEL_OPERATOR =
  '[Record Labels] Create Record Label Operator';
export const CREATE_RECORD_LABEL_OPERATOR_SUCCESS =
  '[Record Labels] Create Record Label Operator Success';
export const CREATE_RECORD_LABEL_OPERATOR_ERROR =
  '[Record Labels] Create Record Label Operator Error';

export const REMOVE_OPERATOR_FROM_RECORD_LABEL =
  '[Record Labels] Remove operator from Record Label';
export const REMOVE_OPERATOR_FROM_RECORD_LABEL_SUCCESS =
  '[Record Labels] Remove operator from Record Label Success';
export const REMOVE_OPERATOR_FROM_RECORD_LABEL_ERROR =
  '[Record Labels] Remove operator  Record Label Error';

export const CREATE_RECORD_LABEL_INVITE = '[Record Labels] Create Invite';
export const CREATE_RECORD_LABEL_INVITE_ERROR =
  '[Record Labels] Create Invite Error';
export const CREATE_RECORD_LABEL_INVITE_SUCCESS =
  '[Record Labels] Create Invite Success';

export const CREATE_OPERATOR_INVITE = '[Record Labels] Create Operator Invite';
export const CREATE_OPERATOR_INVITE_ERROR =
  '[Record Labels] Create Operator Invite Error';
export const CREATE_OPERATOR_INVITE_SUCCESS =
  '[Record Labels] Create Operator Invite Success';

export const LABEL_ONBOARDING_START = '[Record Labels] Start Onboarding';
export const LABEL_ONBOARDING_UPGRADE =
  '[Record Labels] Start Onboarding (Upgrade)';
export const LABEL_ONBOARDING_SELECT_PLAN = '[Record Labels] Select Plan';
export const LABEL_ONBOARDING_UPDATE_NAME = '[Record Labels] Update Name';
export const LABEL_ONBOARDING_ADD_ARTIST = '[Record Labels] Add artist';
export const LABEL_ONBOARDING_REMOVE_ARTIST = '[Record Labels] Remove artist';
export const LABEL_ONBOARDING_SUCCESS = '[Record Labels] Onboarding Success';
